<template>
  <div class="message_template" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="phone" placeholder="请输入手机号码" title="手机号码"/>
      </div>
      <div class="date_selected fixed_search_input">
        <el-date-picker v-model="starEndTime" unlink-panels type="datetimerange" start-placeholder="开始发送时间" end-placeholder="结束发送时间" align="left" :default-time="['00:00:00', '23:59:59']" :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_search_input">
        <Select v-model="isSend" placeholder="请选择发送状态" clearable title="发送状态">
          <Option v-for="(option, index) in judgeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Input v-model="employeeName" placeholder="请输入发送人" title="发送人"/>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button type="info" class="operation_btn" style="margin-left: 10px" @click="exportExcel('5_4-1','短信管理=>发送记录=>导出')" v-if="roleList['5_4-1']">导出</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection" @cell-click="openCallScreen" :cell-class-name="returnClassName" @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <publicPop @closePublicPop="closePublicPop" :showPublicPop="showPublicPop" :popSign="popSign"></publicPop>
    <publicDialerPage  @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer"  :callUpPhone="callUpPhone" ></publicDialerPage>
    <PublicSendMessage  @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage"  :callUpPhone="callUpPhone" ></PublicSendMessage>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
  import publicPop from '@/components/customerMange/PublicPop.vue'
  import publicDialerPage from '@/components/login/PublicDialerPage.vue'
  import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
  export default {
    name: "MessageRecord",
    mixins:[publicFunClass,customerPublicBtn],
    components:{
      publicPop,
      publicDialerPage,
      PublicSendMessage
    },
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        total:0,
        currentPage:1,
        speedChangePage: 1,
        pageSize:20,
        editable:false,
        showPublicPop:false,
        popSign:'短信记录导出',
        pageSizeList:[10,20,30,40,50,100,200],
        roleList:JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        judgeList:[{'id':'0','name':'发送失败'},{'id':'1','name':'发送成功'}],
        starEndTime:[],
        screenHeight:{height:''},
        tableHeight:600,
        spinShow: true,
        checkIds:[],
        fieldList: [
          {type: 'selection', width: 50},{key:'sendBatch','title':'发送批次'},{key:'phone','title':'手机号码'},{key:'customerName','title':'客户名称'},{key:'createTime','title':'发送时间'},
          {key:'content',width:'300','title':'发送内容'},{key:'sendNum','title':'短信条数'},{key:'isSend','title':'发送状态'},{key:'receiveMsg','title':'返回信息'},{key:'employeeName','title':'发送人'}
        ],
        contentList: [],
        employeeName:'',
        phone:'',
        isSend:'',
        queryParam: null,
      }
    },
    methods:{
      exportExcel:function (menuId,journalType) {
        this.journalType=journalType;
        this.menuId=menuId;
        this.showPublicPop=true;
      },
      closePublicPop:function (flag,operateStyle,popSign) {
        this.showPublicPop=false;
        let param={
          ids:this.checkIds.toString(),
          journalType:"'短信管理=>发送记录=>按选中结果"+popSign,
          menuId:"5_4-1",
          type:operateStyle
        };
        if(flag){
          if (operateStyle=='0'){//选中结果
            if (this.checkIds.length==0){
              this.$Modal.info({
                title:'提示',
                content:"请选择需要导出的数据"
              });
              return false;
            }
          }
          if (operateStyle=='1'){//按搜索结果
            if(this.contentList.length==0){
              this.$Modal.info({
                title:'提示',
                content:"当前没有可导出的数据"
              });
              return false;
            }
            if(!this.queryParam){
              this.$Modal.info({
                title:'提示',
                content:"请点击查询后再导出"
              });
              return false;
            }
          delete this.queryParam["pageNum"];
          delete this.queryParam["pageSize"];
          this.$set(this.queryParam, 'journalType',"短信管理=>发送记录=>按搜索结果"+popSign);
          this.$set(this.queryParam, 'menuId', '5_4-1');
          this.$set(this.queryParam, 'type', operateStyle);
          param = this.queryParam;
          }
          this.operateExcelExport(param,"message/expDetailIndex.json");
        }
      },
      reset:function(){
        this.employeeName='';
        this.phone='';
        this.isSend="";
        this.starEndTime=[];
      },
      initSearch:function () {
        let that=this;
        this.spinShow=true;
        let param={
          employeeName:this.employeeName,
          phone:this.phone,
          isSend:this.isSend,
          createTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null"
        };
        this.queryParam = param;
        this.$http.post("message/toDetailIndex.json",param) .then(function (res) {
          that.spinShow=false;
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          let obj=res.data.obj;
          that.contentList=obj.list.content;
          that.total=res.data.obj.list.totalSize;
        });
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-182;
      let phoneIsHide= this.configInfo.phoneIsHide;
      if(phoneIsHide=='1'){
        for (let i=0;i<this.fieldList.length;i++){
          let key=this.fieldList[i].key;
          if(key=="phone"){
            this.fieldList[i].key="phoneHide"
          }
        }
      }
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='5_4' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MessageManage/MessageRecord.vue